import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VisualizarLaudoComponent} from '../visualizar-laudo.component';
import {VisualizarImagemOriginalComponent} from '../../visualizar-imagem-original/visualizar-imagem-original.component';


const visualizarLaudoRotas: Routes = [
  {path: '', component: VisualizarLaudoComponent},
  {path: 'laudo=:laudoNumero&key=:shortGuid', component: VisualizarLaudoComponent},
  {path: 'imagemoriginal/:LaudoVistoriaId/:ShortGuid', component: VisualizarImagemOriginalComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(visualizarLaudoRotas)
  ],
  exports: [RouterModule]
})

export class VisualizarLaudoRotasModule {
}
